import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _cloneDeep from "lodash/cloneDeep";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-param-reassign */
import produce, { current } from 'immer';
import { mergeObjectReplacingArrays } from 'utils/arrayUtils';
import { downsamplingMethods } from 'const';
import initialState from '../initialState';
var setSeuratV4Compatibility = function setSeuratV4Compatibility(step, newConfig) {
  var _newConfig$dataIntegr, _newConfig$downsampli;
  if (step !== 'dataIntegration') return;
  if (((_newConfig$dataIntegr = newConfig.dataIntegration) === null || _newConfig$dataIntegr === void 0 ? void 0 : _newConfig$dataIntegr.method) === 'seuratv4' && ((_newConfig$downsampli = newConfig.downsampling) === null || _newConfig$downsampli === void 0 ? void 0 : _newConfig$downsampli.method) === downsamplingMethods.GEOSKETCH) {
    // Account for possibility of downsampling not existing
    newConfig.downsampling = _objectSpread(_objectSpread({}, newConfig.downsampling), {}, {
      method: downsamplingMethods.NONE
    });
  }
};
var updateNonSampleFilterSettings = produce(function (draft, action) {
  var _current$step;
  var _action$payload = action.payload,
    step = _action$payload.step,
    configChange = _action$payload.configChange,
    isALocalChange = _action$payload.isALocalChange;
  if (!step) throw new Error("Invalid step parameter received: ".concat(step));
  var originalProcessingConfig = (_current$step = current(draft.processing)[step]) !== null && _current$step !== void 0 ? _current$step : {};
  var newConfig = _cloneDeep(originalProcessingConfig);
  mergeObjectReplacingArrays(newConfig, configChange);
  setSeuratV4Compatibility(step, newConfig);
  draft.processing[step] = newConfig;
  if (!isALocalChange) {
    draft.originalProcessing[step] = newConfig;
  }
}, initialState);
export default updateNonSampleFilterSettings;